import type { IAffiliateProgramCommissionFilterStepPayload, ITransactionType } from '@modules/affiliate-program-commissions/submodules/edit/types';
import { isNumber } from '@utils/guards';

export default function isInvalidStep(
  step: IAffiliateProgramCommissionFilterStepPayload,
  typeOfTransaction: ITransactionType,
): boolean {
  if (step.type_in_part_condition !== typeOfTransaction) {
    return false;
  }

  if (typeOfTransaction === 'revenue_share' && !step.payment_column) {
    return true;
  }

  return step.payment_size === undefined || !step.condition_step_items_attributes.every(
    (item) => (item.condition_for_comparison === 'any'
      ? item.obtained_result
      : isNumber(item.desired_value) && item.condition_for_comparison && item.obtained_result),
  );
}
